// extracted by mini-css-extract-plugin
module.exports = {"switch":"themeswitch_switch__3Sra0","slider":"themeswitch_slider__c8TL0","round":"themeswitch_round__oUzWU"};